import { LAST_MESSAGES, GET_MESSAGE_BY_PERSON, IS_LOADING, SEND_MESSAGE, INBOX_TEXT_CHANGED} from '../constants/ActionTypes';
import _ from 'underscore';
import Utils from '../views/reactViews/Utils';

function getInitialState() {
    return {
        isLoading: true,
        lastMessages: [],
        messagesByPerson: {},
        currentMessageText: {}
    };
}


function inboxReducer(state = getInitialState(), action = null) {
    switch (action.type) {
    case LAST_MESSAGES :
    {
        let lastMessages = action.response;
        lastMessages = lastMessages ? Utils.ensureArray(lastMessages) : [];
        return Object.assign({}, state, {
            lastMessages: lastMessages
        });
    }
    case IS_LOADING:
    {
        return Object.assign({}, state, {
            isLoading: action.isLoading
        });
    }
    case GET_MESSAGE_BY_PERSON:
    {
        const lastMessages = state.lastMessages.map((msg) => {
            let read = msg['sourceId'] === action.otherPersonId ? true : msg.read;
            return Object.assign(msg, {read: read});
        });
        return Object.assign({}, state, {
            messagesByPerson: Object.assign({}, state.messagesByPerson, {
                [action.otherPersonId]: action.messagesByPerson
            }),
            lastMessages: lastMessages
        });
    }
    case SEND_MESSAGE:
    {
        let newCurrentMessageText = {};
        newCurrentMessageText[action.otherPersonId] = '';
        state.messagesByPerson[action.otherPersonId] = state.messagesByPerson[action.otherPersonId] || [];
        state.messagesByPerson[action.otherPersonId].push(action.message);
        return Object.assign({}, state, {
            currentMessageText: Object.assign({}, state.currentMessageText, newCurrentMessageText)
        });
    }
    case INBOX_TEXT_CHANGED:
    {
        let newCurrentMessageText = {};
        newCurrentMessageText[action.otherPersonId] = action.text;
        return Object.assign({}, state, {
            currentMessageText: Object.assign({}, state.currentMessageText, newCurrentMessageText)
        });
    }
    default:
    {
        return state;
    }
    }
}

export default inboxReducer;
